// 采销工作台 — Mock 数据（第一阶段）
// 来源：icBot v6.1.15 原型 HTML 中的 CTX / PROCURE_ITEMS / SALES_LINES / AUTO_MATCH 等

// ===== CTX 询价上下文（19条中取核心8条） =====
export const mockCtxList = [
  {
    id: 'CTX-07154', customer: '中兴通讯', title: 'BOM询价·电源管理IC+功率器件·56行',
    status: 'created', priority: 'normal', sales: '周睿', salesId: 'zhourui',
    createdAt: '2025-07-08 09:15', updatedAt: '2025-07-08 09:18',
    inputType: 'bom', inputDesc: '243行·183KB', syncedToErp: true,
    customerType: '终端厂商', progress: 30,
    tasks: [
      { title: 'BOM解析', executor: 'AI', etype: 'ai', status: 'done', result: '56条料号·17条AI匹配' },
      { title: 'API查价', executor: '华秋/Mouser', etype: 'system', status: 'done' }
    ]
  },
  {
    id: 'CTX-07158', customer: '华天科技', title: 'MCU主控芯片·BOM询价',
    status: 'in_progress', priority: 'high', sales: '周睿', salesId: 'zhourui',
    createdAt: '2025-07-08 10:05', updatedAt: '2025-07-08 11:10',
    inputType: 'bom', inputDesc: 'MCU BOM 4型号', syncedToErp: true,
    customerType: '终端厂商', progress: 75,
    tasks: [
      { title: 'BOM解析', executor: 'AI', etype: 'ai', status: 'done' },
      { title: '分配采购员', executor: '陈勇', etype: 'manager', status: 'done' },
      { title: '采购询价', executor: '李立红/陈丽芳/凌云', etype: 'human', status: 'doing' }
    ]
  },
  {
    id: 'CTX-07157', customer: '比亚迪', title: 'DSP处理器·3型号',
    status: 'quoting', priority: 'normal', sales: '李明', salesId: 'liming',
    createdAt: '2025-07-08 13:00', updatedAt: '2025-07-08 16:10',
    inputType: 'text', inputDesc: '3条料号', syncedToErp: true,
    customerType: 'OEM', progress: 100,
    tasks: [
      { title: '采购报价完成', executor: '小兰', etype: 'human', status: 'done' }
    ]
  },
  {
    id: 'CTX-07156', customer: '大疆创新', title: 'FPGA+CPLD·2型号',
    status: 'completed', priority: 'normal', sales: '王芳', salesId: 'wangfang',
    createdAt: '2025-07-08 11:30', updatedAt: '2025-07-08 14:50',
    inputType: 'text', inputDesc: 'FPGA 2型号', syncedToErp: true,
    customerType: 'ODM', progress: 100
  },
  {
    id: 'CTX-07103', customer: '汇顶科技', title: 'Microchip MCU·BOM询价·12型号',
    status: 'won', priority: 'normal', sales: '周睿', salesId: 'zhourui',
    createdAt: '2025-07-07 14:00', updatedAt: '2025-07-08 14:20',
    inputType: 'bom', inputDesc: '12条料号', syncedToErp: true,
    customerType: '终端厂商', progress: 100,
    wonAmount: '¥369,600', wonAt: '2025-07-08 14:20', wonQty: 28000
  },
  {
    id: 'CTX-07163', customer: '拓邦股份', title: 'STM32H743VIT6·单料询价',
    status: 'lost', priority: 'normal', sales: '赵刚', salesId: 'zhaogang',
    createdAt: '2025-07-08 10:25', updatedAt: '2025-07-08 14:40',
    inputType: 'manual', inputDesc: '单料号', syncedToErp: true,
    customerType: 'ODM', progress: 100,
    lossReason: '客户反馈竞品¥26.50现货，我司交期2周偏长', competitorPrice: '¥26.50', lostAt: '2025-07-08 14:40'
  },
  {
    id: 'CTX-07155', customer: '宁德时代', title: '高速接口IC·BOM询价·128型号',
    status: 'in_progress', priority: 'normal', sales: '赵刚', salesId: 'zhaogang',
    createdAt: '2025-07-08 08:00', updatedAt: '2025-07-08 09:20',
    inputType: 'bom', inputDesc: '128条料号·56KB', syncedToErp: true,
    customerType: '终端厂商', progress: 48,
    tasks: [
      { title: 'BOM解析', executor: 'AI', etype: 'ai', status: 'done' },
      { title: '采购询价', executor: '李莉', etype: 'human', status: 'doing' }
    ]
  },
  {
    id: 'CTX-07153', customer: '海康威视', title: 'STM32G4系列·BOM询价',
    status: 'completed', priority: 'normal', sales: '李明', salesId: 'liming',
    createdAt: '2025-07-08 09:00', updatedAt: '2025-07-08 13:45',
    inputType: 'bom', inputDesc: '36条料号', syncedToErp: true,
    customerType: '终端厂商', progress: 100
  }
]

// ===== PROCURE_ITEMS 采购品项（选取代表性数据） =====
export const mockProcureItems = [
  {
    id: 'PI-001', buyer: '陈丽芳', ctxId: 'CTX-07154', model: 'BD9611MUV-E2',
    brand: 'ROHM', pkg: 'VQFN-24', qty: 1500, batchReq: '24+', leadReq: '4周',
    customerType: '终端厂商', targetPrice: '¥35.00', sales: '周睿',
    createdAt: '2025-07-08 09:20', urgency: 'normal', status: 'pending',
    recs: [
      { s: '华秋商城', p: '¥36.50', m: '100', l: '3天', src: 'API实时' },
      { s: 'Mouser', p: '¥28.50', m: '500', l: '1周', src: 'API实时' }
    ]
  },
  {
    id: 'PI-002', buyer: '李立红', ctxId: 'CTX-07154', model: 'TPS63020DSJR',
    brand: 'TI', pkg: 'SON-14', qty: 2000, batchReq: '24+', leadReq: '2周',
    customerType: '终端厂商', targetPrice: '¥15.00', sales: '周睿',
    createdAt: '2025-07-08 09:20', urgency: 'normal', status: 'doing',
    feedback: [{ from: '李立红(采购)', time: '2025-07-08 10:00', msg: '华秋¥15.80现货，Mouser需1周但便宜¥1.30。' }],
    recs: [
      { s: '华秋商城', p: '¥15.80', m: '500', l: '现货', src: 'API实时' },
      { s: 'Mouser', p: '.95', m: '1000', l: '1周', src: 'API实时' }
    ]
  },
  {
    id: 'PI-003', buyer: '李立红', ctxId: 'CTX-07158', model: 'STM32H743VIT6',
    brand: 'ST', pkg: 'LQFP-100', qty: 2000, batchReq: '24+', leadReq: '2周',
    customerType: '终端厂商', targetPrice: '¥30.00', sales: '周睿',
    createdAt: '2025-07-08 10:15', urgency: 'high', status: 'doing',
    feedback: [
      { from: '李立红(采购)', time: '2025-07-08 10:28', msg: '艾睿已报¥32.50，安富利也快了。' },
      { from: '陈丽芳(采购)', time: '2025-07-08 10:15', msg: '安富利报价¥32.00更低，MOQ仅500。' }
    ],
    recs: [
      { s: '艾睿电子', p: '¥32.50', m: '1000', l: '4周', src: 'icHub历史' },
      { s: '安富利', p: '¥32.00', m: '500', l: '1周', src: 'icHub历史' }
    ]
  },
  {
    id: 'PI-004', buyer: '小兰', ctxId: 'CTX-07157', model: 'TMS320F28335PGFA',
    brand: 'TI', pkg: 'LQFP-176', qty: 2000, batchReq: '24+', leadReq: '12周',
    customerType: 'OEM', targetPrice: '¥185.00', sales: '李明',
    createdAt: '2025-07-08 13:10', urgency: 'normal', status: 'done',
    recs: [{ s: 'Mouser', p: '5.30', m: '100', l: '12周', src: 'API实时' }]
  },
  {
    id: 'PI-005', buyer: '凌云', ctxId: 'CTX-07156', model: 'XC7A35T-2FGG484I',
    brand: 'Xilinx', pkg: 'FBGA-484', qty: 1200, batchReq: '24+', leadReq: '8周',
    customerType: 'ODM', targetPrice: '¥580.00', sales: '王芳',
    createdAt: '2025-07-08 11:40', urgency: 'normal', status: 'done',
    recs: [
      { s: '艾睿电子', p: '¥585.00', m: '10', l: '8周', src: 'icHub历史' },
      { s: '安富利', p: '¥620.00', m: '5', l: '6周', src: 'icHub历史' }
    ]
  },
  {
    id: 'PI-006', buyer: '陈丽芳', ctxId: 'CTX-07103', model: 'ATmega328P-AU',
    brand: 'Microchip', pkg: 'TQFP-32', qty: 5000, batchReq: '24+', leadReq: '现货',
    customerType: '终端厂商', targetPrice: '¥6.80', sales: '周睿',
    createdAt: '2025-07-08 10:00', urgency: 'normal', status: 'done',
    recs: [{ s: '华秋商城', p: '¥6.80', m: '2500', l: '现货', src: 'API实时' }]
  }
]

// ===== SALES_LINES 线项汇总 =====
export const mockSalesLines = {
  'CTX-07154': { total: 56, quoted: 17, items: [
    { model: 'BD9611MUV-E2', brand: 'ROHM', qty: '1,500', buyer: '陈丽芳', status: 'inquiring' },
    { model: 'TPS63020DSJR', brand: 'TI', qty: '2,000', buyer: '李立红', status: 'inquiring' },
    { model: 'LMR33630CDDA', brand: 'TI', qty: '1,000', buyer: '陈丽芳', status: 'inquiring' }
  ]},
  'CTX-07158': { total: 4, quoted: 3, items: [
    { model: 'STM32H743VIT6', brand: 'ST', qty: '2,000', buyer: '李立红/陈丽芳/凌云',
      quotedAt: '2025-07-08 11:10', status: 'quoted',
      quotes: [
        { price: '¥32.50', supplier: '李立红·艾睿电子', moq: '1,000', lead: '4周', pkg: 'Tray', dc: '24+', buyer: '李立红' },
        { price: '¥32.00', supplier: '陈丽芳·安富利', moq: '500', lead: '1周', pkg: 'Tray', dc: '24+', buyer: '陈丽芳' },
        { price: '¥29.50', supplier: '凌云·原厂直供', moq: '5,000', lead: '现货', pkg: '卷带', dc: '23+', buyer: '凌云' }
      ],
      feedback: [
        { from: '李立红(采购)', time: '2025-07-08 10:28', msg: '艾睿已报¥32.50。' },
        { from: '陈丽芳(采购)', time: '2025-07-08 10:15', msg: '安富利报价¥32.00更低，MOQ仅500。' }
      ]
    },
    { model: 'STM32H750VBT6', brand: 'ST', qty: '1,500', buyer: '李立红',
      quotedAt: '2025-07-08 10:05', price: '¥28.00', moq: '500', lead: '2周', pkg: 'Tray', dc: '24+', status: 'quoted'
    },
    { model: 'TPS54360DDAR', brand: 'TI', qty: '5,000', buyer: '陈丽芳',
      quotedAt: '2025-07-08 09:42', price: '¥4.80', moq: '2,000', lead: '3天', pkg: '卷带', dc: '24+', status: 'quoted'
    },
    { model: 'GD32F103C8T6', brand: 'GigaDevice', qty: '10,000', buyer: '李立红', status: 'inquiring' }
  ]},
  'CTX-07157': { total: 3, quoted: 3, items: [
    { model: 'TMS320F28335PGFA', brand: 'TI', qty: '2,000', buyer: '小兰',
      quotedAt: '2025-07-08 15:50', price: '¥185.00', moq: '100', lead: '12周', pkg: 'Tray', dc: '24+', status: 'quoted'
    },
    { model: 'TMS320F280049CPMS', brand: 'TI', qty: '1,500', buyer: '小兰',
      quotedAt: '2025-07-08 15:30', price: '¥78.00', moq: '200', lead: '8周', pkg: '卷带', dc: '24+', status: 'quoted'
    },
    { model: 'TMS320F28379DPTP', brand: 'TI', qty: '1,000', buyer: '小兰',
      quotedAt: '2025-07-08 16:10', price: '¥215.00', moq: '100', lead: '12周', pkg: 'Tray', dc: '24+', status: 'quoted'
    }
  ]},
  'CTX-07156': { total: 2, quoted: 2, items: [
    { model: 'XC7A35T-2FGG484I', brand: 'Xilinx', qty: '1,200', buyer: '凌云',
      quotedAt: '2025-07-08 14:45', status: 'quoted',
      quotes: [
        { price: '¥585.00', supplier: '艾睿电子', moq: '10', lead: '8周', pkg: 'Tray', dc: '24+' },
        { price: '¥620.00', supplier: '安富利', moq: '5', lead: '6周', pkg: 'Tray', dc: '23+' }
      ]
    },
    { model: 'EP4CE22F17C8N', brand: 'Intel', qty: '2,000', buyer: '凌云',
      quotedAt: '2025-07-08 14:50', price: '¥58.00', moq: '100', lead: '现货', pkg: 'Tray', dc: '24+', status: 'quoted'
    }
  ]},
  'CTX-07103': { total: 12, quoted: 12, items: [
    { model: 'ATmega328P-AU', brand: 'Microchip', qty: '8,000', buyer: '陈丽芳',
      quotedAt: '2025-07-08 14:20', price: '¥6.80', moq: '100', lead: '现货', pkg: 'Tray', dc: '24+', status: 'quoted'
    },
    { model: 'ATmega2560-16AU', brand: 'Microchip', qty: '3,000', buyer: '陈丽芳',
      quotedAt: '2025-07-08 14:15', price: '¥24.50', moq: '100', lead: '1周', pkg: 'Tray', dc: '24+', status: 'quoted'
    },
    { model: 'ATTiny85-20PU', brand: 'Microchip', qty: '15,000', buyer: '陈丽芳',
      quotedAt: '2025-07-08 14:10', price: '¥3.60', moq: '1,000', lead: '3天', pkg: 'Tube', dc: '24+', status: 'quoted'
    }
  ]}
}

// ===== AUTO_MATCH 自动匹配价格 =====
export const mockAutoMatch = {
  'CTX-07154': [
    { model: 'BD9611MUV-E2', brand: 'ROHM', source: '华秋商城', price: '¥36.50', moq: 100, lead: '3天', updatedAt: '2025-07-08', priceType: 'a' },
    { model: 'TPS63020DSJR', brand: 'TI', source: '华秋商城', price: '¥15.80', moq: 500, lead: '现货', updatedAt: '2025-07-08', priceType: 'a' },
    { model: 'TPS63020DSJR', brand: 'TI', source: 'icHub历史', price: '¥14.50', moq: 1000, lead: '2周', updatedAt: '2025-06-15', priceType: 'a' },
    { model: 'LMR33630CDDA', brand: 'TI', source: 'Mouser', price: '¥11.80', moq: 1000, lead: '1周', updatedAt: '2025-07-08', priceType: 'a' },
    { model: 'MP2315GJ-Z', brand: 'MPS', source: '华秋商城', price: '¥5.80', moq: 300, lead: '现货', updatedAt: '2025-07-08', priceType: 'a' }
  ],
  'CTX-07158': [
    { model: 'STM32H743VIT6', brand: 'ST', source: '华秋商城', price: '¥32.50', moq: 500, lead: '3天', updatedAt: '2025-07-08', priceType: 'a' },
    { model: 'STM32H743VIT6', brand: 'ST', source: 'Mouser', price: '¥29.80', moq: 1000, lead: '2周', updatedAt: '2025-07-08', priceType: 'a' }
  ]
}

// ===== ORDER_TASKS 履约任务 =====
export const mockOrderTasks = [
  { type: 'pickup', id: 'PICK-001', ctxId: 'CTX-07103', supplier: '艾睿电子', item: 'STM32H743VIT6 x2000', amount: '¥65,000', status: '待提货', dueDate: '2025-07-10', sales: '周睿' },
  { type: 'pickup', id: 'PICK-002', ctxId: 'CTX-07072', supplier: 'Mouser', item: 'TMS320F28335PGFA x500', amount: '¥92,500', status: '待提货', dueDate: '2025-07-09', sales: '李明' },
  { type: 'payment', id: 'PAY-07198', supplier: '艾睿电子', amount: '¥34,000', status: '待付款', dueDate: '2025-07-12' },
  { type: 'shipment', id: 'SHP-07200', supplier: '安富利', item: 'ATmega2560-16AU x2000', status: '运输中', eta: '2025-07-14' },
  { type: 'shipment', id: 'SHP-07185', supplier: 'Mouser', item: 'ATTiny85-20PU x3000', status: '已签收', eta: '2025-07-08' },
  { type: 'invoice', id: 'INV-07195', supplier: '艾睿电子', item: 'ATmega328P-AU x5000', amount: '¥34,000', status: '待开发票', dueDate: '2025-07-15' }
]

// ===== POOL_ITEMS 需求池 =====
export const mockPoolItems = [
  { id: 'POOL-001', model: 'STM32F407VGT6', brand: 'ST', pkg: 'LQFP-100', qty: 3000, batchReq: '24+', leadReq: '2周', targetPrice: '¥25.00', desc: '客户预询·新能源BOM·预计下周正式下单', createdAt: '2025-07-08 16:00' },
  { id: 'POOL-002', model: 'ESP32-S3-WROOM-1-N16R8', brand: 'Espressif', pkg: 'Module', qty: 5000, batchReq: '24+', leadReq: '1周', targetPrice: '¥30.00', desc: 'IoT项目备货·已有3个客户意向', createdAt: '2025-07-08 15:30' }
]

// ===== MESSAGES 消息 =====
export const mockMessages = [
  { id: 'MSG-001', type: 'quote_done', from: 'icBot', fromRole: 'system', to: '周睿', toRole: 'sales', subject: 'CTX-07157 报价完成', content: '3/3条全部报价完成，请生成报价单发送给比亚迪', time: '2025-07-08 16:10', ctxId: 'CTX-07157', read: false },
  { id: 'MSG-002', type: 'assign', from: '陈勇', fromRole: 'manager', to: '李立红', toRole: 'procure', subject: '新任务分配', content: '已分配 CTX-07154 的 TPS63020DSJR 给你，请尽快处理', time: '2025-07-08 10:05', ctxId: 'CTX-07154', read: true },
  { id: 'MSG-003', type: 'urge', from: '周睿', fromRole: 'sales', to: '陈丽芳', toRole: 'procure', subject: '催办：CTX-07154 待报价', content: '中兴通讯在催进度，请尽快完成报价', time: '2025-07-08 13:00', ctxId: 'CTX-07154', read: false },
  { id: 'MSG-004', type: 'bargain', from: '李立红', fromRole: 'procure', to: '周睿', toRole: 'sales', subject: '还价：STM32H743VIT6', content: '艾睿最低¥32.50，客户目标价¥30.00有差距，是否接受？', time: '2025-07-08 11:00', ctxId: 'CTX-07158', read: false },
  { id: 'MSG-005', type: 'order', from: 'icBot', fromRole: 'system', to: '周睿', toRole: 'sales', subject: '下单成功', content: 'CTX-07103 已一键转下单，销售单号 SO-07103，采购单号 PO-07201', time: '2025-07-08 14:30', ctxId: 'CTX-07103', read: true }
]
